import React, { Fragment } from 'react';
import { MdEdit } from 'react-icons/md';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import Link from '../link';

/**
 * Detail title
 */
const DetailTitle = styled.div`
  display: flex;
  justify-content: space-between;
  span {
    margin-right: 0.3em;
  }
`;

/**
 * Detail inner content
 */
const DetailContent = styled.div`
  justify-self: stretch;
  text-align: right;
  div {
    text-align: right;
  }
`;

const Detail = ({ title, pathname, children }) => {
  return (
    <Fragment>
      <DetailTitle>
        <span>
          <Translate id={`checkout.review.${title}`} />
        </span>
        {pathname && (
          <Link to={pathname + window.location.search}>
            <MdEdit />
          </Link>
        )}
      </DetailTitle>
      <DetailContent>{children}</DetailContent>
    </Fragment>
  );
};

export default Detail;
